import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, useMemo } from 'react'

import { ImageV3 } from '@Components/Image'
import { useMediaQuery } from '@Globals/useMediaQuery'
import { PageSliderProps } from '@PagesDomain/Features/PageSlider/PageSlider.types'
import { HorizontalCarousel } from '@Shared/Components/Carousels/HorizontalCarousel/HorizontalCarousel'

import styles from './PageSlider.module.scss'

export const PageSlider: FC<PageSliderProps> = ({ items, title }) => {
  const deviceIsTablet = useMediaQuery('(min-width: 768px)')
  const content = useMemo(() => map(items, item => (
    <a
      key={`page-slider-item-${item.title}`}
      draggable={false}
      href={item.url}
    >
      <div className={styles.imageWrapper}>
        <ImageV3
          alt={item.description}
          draggable={false}
          height={deviceIsTablet ? 221 : 162}
          src={item.imageUrl}
          width={deviceIsTablet ? 384 : 265}
        />
      </div>
      <h3 className={styles.itemHeader}>{item.title}</h3>
      <p className={styles.itemDescription}>{item.description}</p>
    </a>
  )), [deviceIsTablet, items])

  if (!content) {
    return null
  }
  return (
    <div className={clsx(styles.pageSlider)}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <HorizontalCarousel buttonClassName={styles.arrows} buttonFloat carouselClassName={styles.carousel} gap={deviceIsTablet ? 24 : 10} showButtons snap>
        {content}
      </HorizontalCarousel>
    </div>
  )
}
